import styled from '@emotion/styled'
import { ReactComponent as EmailSentIcon } from '../../assets/email_sent.svg'

export const EmailSentIconStyle = styled(EmailSentIcon)(() => ({
  hight: '48px',
  width: '56px'
}))
